import { CompoundFilterStateOption } from './CompoundFilter.types';
import { resolveCompoundFilterStateModifiers } from './helpers';

export const clearOptions = (options: CompoundFilterStateOption[]) => {
  return options
    .filter((option) => {
      const { isRemovable } = resolveCompoundFilterStateModifiers(option?.stateModifiers);
      return !isRemovable;
    })
    .map((option) => {
      const { isClearable, isActive } = resolveCompoundFilterStateModifiers(option?.stateModifiers);
      return {
        ...option,
        stateModifiers: { ...option.stateModifiers, isActive: isClearable ? false : isActive },
      };
    });
};
